export const mapper = {
    0: 'S',
    1: 'A',
    2: 'N',
    3: 'T',
    4: 'I',
    5: 'P',
    6: 'Y',
    7: 'U',
    8: 'O',
    9: 'K',
}

export const salt = 543


// WEBPACK FOOTER //
// ./src/hashMap.js